import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import {
  createTeamMember,
  getAllTeamMember,
  getTeamMemberByID,
  TeamMemberImageUpload,
  updateTeamMember,
} from "./services/teamMember.services";
import { clearTeamMemberDetail } from "./teamMemberSlice";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { RxCross1 } from "react-icons/rx";
import FormImageUploadMorden from "../../components/formFields/formImageUploadMorden";

const CreateTeamMember: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const TeamMemberID = useAppSelector((state) => state.muidrawer.data);
  const TeamMemberDetail = useAppSelector(
    (state) => state.teammember.TeamMemberDetail
  );
  const loading = useAppSelector((state) => state.teammember.formLoading);

  useEffect(() => {
    if (TeamMemberID) {
      dispatch(getTeamMemberByID(TeamMemberID));
    }
    return () => {
      dispatch(clearTeamMemberDetail());
    };
  }, [TeamMemberID]);

  const handleSubmit = async (values: any) => {
    const formData = {
      SequenceNo: values?.SequenceNo ? values?.SequenceNo : 0,
      Name: values?.Name ? values?.Name : "",
      Designation: values?.Designation ? values?.Designation : "",
      Facebook: values?.Facebook ? values?.Facebook : "",
      xlink: values?.xlink ? values?.xlink : "",
      Linkedin: values?.Linkedin ? values?.Linkedin : "",
      InstaLink: values?.InstaLink ? values?.InstaLink : "",
      IsActive: values.IsActive === 1,
    };
    const ImageData = new FormData();
    const TeamMemberImage =
      values?.Image &&
      typeof values?.Image !== "string" &&
      Array.isArray(values?.Image) &&
      values?.Image?.length > 0
        ? values.Image[0].getRawFile()
        : "";

    try {
      if (TeamMemberID) {
        const editPayload = {
          ...formData,
          ID: TeamMemberID,
        };

        const response = await dispatch(updateTeamMember(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());

          if (
            values?.Image &&
            typeof values?.Image !== "string" &&
            Array.isArray(values?.Image) &&
            values?.Image?.length > 0
          ) {
            ImageData.append("Image", TeamMemberImage);
            ImageData.append("ID", TeamMemberID);
            await dispatch(TeamMemberImageUpload(ImageData));
          }
          dispatch(getAllTeamMember());
          dispatch(clearTeamMemberDetail());
        }
      } else {
        const response = await dispatch(createTeamMember(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          if (
            values?.Image &&
            typeof values?.Image !== "string" &&
            Array.isArray(values?.Image) &&
            values?.Image?.length > 0 &&
            response?.payload?.Data?.ID
          ) {
            ImageData.append("Image", TeamMemberImage);

            ImageData.append("ID", response?.payload?.Data?.ID);
            await dispatch(TeamMemberImageUpload(ImageData));
          }
          dispatch(getAllTeamMember());
          dispatch(clearTeamMemberDetail());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div>
        <Form
          onSubmit={handleSubmit}
          initialValues={TeamMemberDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <GridLayout
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
                gap={{ rows: 10 }}
                cols={[{ width: "100%" }]}
              >
                <GridLayoutItem className="master-drawer-header">
                  <Typography.h4 className="m-0">
                    {TeamMemberID ? "Update Team Member" : "Create Team Member"}
                  </Typography.h4>
                  <Button
                    type="button"
                    fillMode={"flat"}
                    themeColor={"dark"}
                    style={{ marginRight: 4 }}
                    onClick={() => dispatch(closed())}
                  >
                    <RxCross1 />
                  </Button>
                </GridLayoutItem>

                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name="Name"
                    label="Team Member Name"
                    placeholder="i.e. Jhone Doe"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name="SequenceNo"
                    label="Sequence No"
                    placeholder="i.e. 1"
                    type="number"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name="Designation"
                    label="Designation"
                    placeholder="i.e. Project Manager"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name="xlink"
                    label="X Link"
                    placeholder="i.e. https://twitter.com/username"
                    component={FormTextField}
                    // validator={requiredValidator}
                    // astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name="Facebook"
                    label="Facebook Link"
                    placeholder="i.e. https://facebook.com/username"
                    component={FormTextField}
                    // validator={requiredValidator}
                    // astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name="Linkedin"
                    label="LinkedIn Link"
                    placeholder="i.e. https://linkedin.com/username"
                    component={FormTextField}
                    // validator={requiredValidator}
                    // astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name="InstaLink"
                    label="Instagram Link"
                    placeholder="i.e. https://instagram.com/username"
                    component={FormTextField}
                    // validator={requiredValidator}
                    // astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    justifyContent="start"
                    name={`Image`}
                    label="Team Member Image"
                    type="file"
                    accept="image/*"
                    alternateName="team-member-image"
                    component={FormImageUploadMorden}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name={`IsActive`}
                    label="Status"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "end",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={TeamMemberID ? "Update" : "Create"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"secondary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => dispatch(closed())}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateTeamMember;
